if (!customElements.get('lastar-delivery')) {
  customElements.define('lastar-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.region = this.querySelector('select');
      this.message = this.querySelector('[data-delivery-message]');
      this.region.addEventListener('change', () => this.update(), {signal: this.abort.signal});
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.update(); }, {signal: this.abort.signal});
      this.timer = setInterval(() => this.update(), 60000);
      this.update();
    }
    update() {
      const now = new Date();
      const us = this.region.value === 'US';
      const key = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}-${us}`;
      if (this.lastKey === key) return;
      this.lastKey = key;
      const days = us ? [3, 5] : [5, 15];
      // Calendar arithmetic keeps the arrival dates correct across DST and month boundaries.
      const dates = days.map(day => new Date(now.getFullYear(), now.getMonth(), now.getDate() + day, 12));
      const format = new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', ...(dates[0].getFullYear() !== dates[1].getFullYear() ? {year: 'numeric'} : {})});
      const range = document.createElement('strong');
      range.textContent = `${format.format(dates[0])} \u2013 ${format.format(dates[1])}`;
      this.message.replaceChildren(document.createTextNode('Order now \u2014 estimated arrival '), range, document.createTextNode(` (${days[0]}\u2013${days[1]} days).`));
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.abort = null;
      this.lastKey = null;
    }
  });
}
